import React from "react";
import { useNavigate } from "react-router-dom";

import "../Styles/Login.css";

import axios from "axios";

import Cookies from 'js-cookie';

export default function Login(props) {
    const navigate = useNavigate();
    const [updateNav,setUpdateNav] = props.updatenav;
    function sendForm(event) {
        event.preventDefault();
        const form = event.target.parentElement;
        const email = form.email.value;
        const password = form.password.value;

        if (email === "" || password === "") {
            alert("Veuillez remplir tous les champs");
            return;
        }

        const data = new FormData();
        data.append("email", email);
        data.append("password", password);

        axios.post("https://anatole-sot.xyz/api/recettes-gibli/login.php", data)
        .then((response) => {
            if (response.data.status === "success") {
                alert("Vous êtes connecté");
                Cookies.set("token", response.data.data.token, { expires: 7, path: '../' });
                setUpdateNav(!updateNav);
                navigate("/");
            } else {
                alert(response.data.data);
            }
        })
        .catch((error) => {
            console.log(error);
        }
        );
    }
    return (
        <div className="Login">
            <h2>Login</h2>
            <form>
                <label htmlFor="email">Email / Nom d'utilisateur</label>
                <input type="email" name="email" id="email" required />
                <label htmlFor="password">Mot de passe</label>
                <input type="password" name="password" id="password" autoComplete="current-password"required />
                <button type="submit" onClick={sendForm}>Se connecter</button>
            </form>
        </div>
    );
}